import { IMapState } from '../../types';

export function selectIsInfrastructureOnMapEnabled(state: IMapState): boolean {
  return state.map.infrastructure.config.enabled;
}
